(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-clearance-progress"] && !Shopify.designMode) return;
  try {
    const inventoryEndpoint = 'https://ufh5e7d5d6bs3xsonudp672kxy0urmqm.lambda-url.us-east-1.on.aws/';
  const inventoryRequests = new Map();
  const inventoryQueue = [];
  const inventoryAnimations = new Set();
  const inventoryConcurrencyLimit = 4;
  const inventoryAnimationDuration = 800;
  let activeInventoryRequests = 0;
  let inventoryAnimationFrame;

  function updateInventoryAnimations() {
    inventoryAnimationFrame = undefined;
    inventoryAnimations.forEach((element) => element.updateAnimation());
    if (inventoryAnimations.size > 0) {
      inventoryAnimationFrame = requestAnimationFrame(updateInventoryAnimations);
    }
  }

  async function fetchRemainingPercentBySku(sku) {
    const url = new URL(inventoryEndpoint, window.location.origin);
    url.searchParams.set('sku', sku);

    const response = await fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'omit',
      signal: AbortSignal.timeout(5000),
    });

    if (!response.ok) throw new Error('Unable to load clearance inventory');

    const inventory = await response.json();
    const remainingPercent = inventory?.remaining_percent;
    if (typeof remainingPercent !== 'number' || !Number.isFinite(remainingPercent)) {
      throw new Error('Invalid clearance inventory');
    }

    return remainingPercent;
  }

  function processInventoryQueue() {
    while (activeInventoryRequests < inventoryConcurrencyLimit && inventoryQueue.length > 0) {
      const { sku, resolve, reject } = inventoryQueue.shift();
      activeInventoryRequests += 1;

      fetchRemainingPercentBySku(sku)
        .then(resolve, (error) => {
          inventoryRequests.delete(sku);
          reject(error);
        })
        .finally(() => {
          activeInventoryRequests -= 1;
          processInventoryQueue();
        });
    }
  }

  function getRemainingPercentBySku(sku) {
    if (!inventoryRequests.has(sku)) {
      const request = new Promise((resolve, reject) => {
        inventoryQueue.push({ sku, resolve, reject });
      });
      inventoryRequests.set(sku, request);
      processInventoryQueue();
    }

    return inventoryRequests.get(sku);
  }

  if (!customElements.get('clearance-stock-progress')) {
    customElements.define(
      'clearance-stock-progress',
      class ClearanceStockProgress extends HTMLElement {
        async connectedCallback() {
          this.fillElement = this.querySelector('.clearance-stock-progress__fill');
          this.labelElement = this.querySelector('.clearance-stock-progress__label');
          this.labelTemplate = this.dataset.labelTemplate;
          const [labelBefore, labelAfter = ''] = this.labelTemplate.split('__percent__');
          this.numberElement = document.createElement('span');
          this.numberElement.className = 'clearance-stock-progress__number';
          this.numberText = document.createTextNode('0');
          this.numberElement.append(this.numberText);
          this.labelElement.replaceChildren(labelBefore, this.numberElement, labelAfter);
          this.displayedPercent = undefined;
          this.updateProgress(0);
          const sku = this.dataset.sku?.trim().toUpperCase();
          if (!sku || !inventoryEndpoint) return;

          try {
            const remainingPercent = await getRemainingPercentBySku(sku);
            if (!this.isConnected || this.dataset.sku?.trim().toUpperCase() !== sku) return;

            const percent = Math.min(100, Math.max(0, Math.round(remainingPercent)));
            this.animateProgress(percent);
          } catch {
            return;
          }
        }

        disconnectedCallback() {
          inventoryAnimations.delete(this);
          this.fillAnimation?.cancel();
          this.fillAnimation = undefined;
        }

        updateProgress(value) {
          this.fillElement.style.transform = `scaleX(${value / 100})`;
          this.updateLabel(value);
        }

        updateLabel(value) {
          const percent = Math.floor(value);
          if (percent === this.displayedPercent) return;
          this.displayedPercent = percent;
          const label = this.labelTemplate.replace('__percent__', String(percent));

          this.numberText.data = String(percent);
          this.setAttribute('aria-valuenow', String(percent));
          this.setAttribute('aria-valuetext', label);
        }

        animateProgress(percent) {
          this.fillAnimation?.cancel();
          const labelTemplate =
            percent === 100
              ? this.dataset.fullLabelTemplate || this.dataset.labelTemplate
              : this.dataset.labelTemplate;

          if (labelTemplate !== this.labelTemplate) {
            this.labelTemplate = labelTemplate;
            const [labelBefore, labelAfter = ''] = labelTemplate.split('__percent__');
            this.labelElement.replaceChildren(labelBefore, this.numberElement, labelAfter);
            this.displayedPercent = undefined;
          }

          this.numberElement.style.inlineSize = `${String(percent).length}ch`;

          if (percent === 0) {
            inventoryAnimations.delete(this);
            this.updateProgress(percent);
            return;
          }

          const animation = this.fillElement.animate(
            [{ transform: 'scaleX(0)' }, { transform: `scaleX(${percent / 100})` }],
            {
              duration: inventoryAnimationDuration,
              easing: 'cubic-bezier(0.333333, 0.666667, 0.666667, 1)',
              fill: 'both',
            }
          );
          this.fillAnimation = animation;
          this.targetPercent = percent;
          inventoryAnimations.add(this);
          if (inventoryAnimationFrame === undefined) {
            inventoryAnimationFrame = requestAnimationFrame(updateInventoryAnimations);
          }
        }

        updateAnimation() {
          const animation = this.fillAnimation;
          if (!this.isConnected || !animation) {
            inventoryAnimations.delete(this);
            return;
          }

          const progress = animation.effect.getComputedTiming().progress ?? 0;
          this.updateLabel(this.targetPercent * progress);

          if (progress === 1) {
            this.updateProgress(this.targetPercent);
            animation.cancel();
            this.fillAnimation = undefined;
            inventoryAnimations.delete(this);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    const layoutRows = ['promotion', 'tags', 'title', 'details', 'price', 'progress', 'volume'];
  const productGrids = new Map();
  const pendingGrids = new Set();
  const supportsSubgrid = CSS.supports('grid-template-rows', 'subgrid') && CSS.supports('selector(:has(*))');
  let layoutFrame;

  function usesNativeLayout(grid) {
    return supportsSubgrid && grid.matches('.grid:not(.swiper-wrapper):not(.slider)');
  }

  function scheduleLayout(grid) {
    pendingGrids.add(grid);
    if (layoutFrame) return;

    layoutFrame = requestAnimationFrame(() => {
      layoutFrame = undefined;
      const measurements = [];

      pendingGrids.forEach((productGrid) => {
        if (!productGrid.isConnected) return;
        const heights = Object.fromEntries(layoutRows.map((row) => [row, 0]));

        productGrids.get(productGrid)?.forEach((element) => {
          const height = element.getBoundingClientRect().height;
          if (!height) return;
          const style = getComputedStyle(element);
          const outerHeight = height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
          const row = element.dataset.cardLayoutRow;
          heights[row] = Math.max(heights[row], Math.ceil(outerHeight));
        });

        measurements.push([productGrid, heights]);
      });
      pendingGrids.clear();

      measurements.forEach(([productGrid, heights]) => {
        layoutRows.forEach((row) => {
          const property = `--card-${row}-height`;
          const value = `${heights[row]}px`;
          if (productGrid.style.getPropertyValue(property) !== value) {
            productGrid.style.setProperty(property, value);
          }
        });
      });
    });
  }

  const rowObserver = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => {
      const grid = target.closest('.product-grid');
      if (grid) scheduleLayout(grid);
    });
  });

  function observeProductGrids() {
    productGrids.forEach((rows, grid) => {
      if (grid.isConnected && !usesNativeLayout(grid)) return;
      rows.forEach((row) => rowObserver.unobserve(row));
      productGrids.delete(grid);
    });

    document.querySelectorAll('.product-grid').forEach((grid) => {
      if (usesNativeLayout(grid)) return;
      const previousRows = productGrids.get(grid) || new Set();
      const rows = new Set(
        [...grid.querySelectorAll('[data-card-layout-row]')].filter((row) => row.closest('.product-grid') === grid)
      );

      previousRows.forEach((row) => {
        if (!rows.has(row)) rowObserver.unobserve(row);
      });
      rows.forEach((row) => {
        if (!previousRows.has(row)) rowObserver.observe(row);
      });

      productGrids.set(grid, rows);
      scheduleLayout(grid);
    });
  }

  observeProductGrids();

  new MutationObserver((records) => {
    const changedCards = records.some((record) =>
      [...record.addedNodes, ...record.removedNodes].some(
        (node) =>
          node instanceof Element &&
          (node.matches('.product-grid, [data-card-layout-row]') ||
            node.querySelector('.product-grid, [data-card-layout-row]'))
      )
    );
    if (changedCards) observeProductGrids();
  }).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gift-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-gift-set')) {
    customElements.define('product-gift-set', class extends HTMLElement {
      connectedCallback() {
        this.onReady = () => this.initializeCarousel();
        this.breakpoint = window.matchMedia('(min-width: 750px)');
        this.onBreakpointChange = () => {
          this.destroyCarousel();
          this.initializeCarousel();
        };
        this.breakpoint.addEventListener('change', this.onBreakpointChange);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          this.initializeCarousel();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
        this.breakpoint.removeEventListener('change', this.onBreakpointChange);
        this.destroyCarousel();
      }

      initializeCarousel() {
        if (!this.isConnected) return;
        const carousel = this.querySelector('.gift-set-products__carousel');
        if (!carousel) return;
        const enabled = this.breakpoint.matches
          ? carousel.dataset.pcOpenSwiper === 'true'
          : carousel.dataset.mOpenSwiper === 'true';
        carousel.classList.toggle('swiper-container', enabled);
        const list = carousel.querySelector('.gift-set-products__list');
        list.classList.toggle('swiper-wrapper', enabled);
        list.classList.toggle('swiper-product-grid', enabled);
        if (enabled && typeof initSwiper === 'function') initSwiper(this);
      }

      destroyCarousel() {
        const carousel = this.querySelector('.gift-set-products__carousel');
        carousel?.swiper?.destroy(false, true);
        carousel?.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(button => {
          button.classList.add('display-none');
        });
        carousel?.querySelector('.swiper-pagination')?.replaceChildren();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-link-other"] && !Shopify.designMode) return;
  try {
    const revealSelectedProductLink = (container, selectedOption) => {
    if (!container.classList.contains('product-link-other--images') || !selectedOption) return;

    const track = container.querySelector('.product-link-other__options');
    if (!track.clientWidth) return;

    const trackBounds = track.getBoundingClientRect();
    const optionBounds = selectedOption.getBoundingClientRect();
    if (optionBounds.left < trackBounds.left || optionBounds.right > trackBounds.right) {
      track.scrollBy({ left: optionBounds.left - trackBounds.left, behavior: 'instant' });
    }
  };

  const selectProductLink = (container, selectedOption) => {
    container.querySelectorAll('.product-link-other__option').forEach((option) => {
      if (option === selectedOption) {
        option.setAttribute('aria-current', 'page');
      } else {
        option.removeAttribute('aria-current');
      }
    });
    revealSelectedProductLink(container, selectedOption);
  };

  const productLinkResizeObserver = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => {
      if (!target.isConnected) {
        productLinkResizeObserver.unobserve(target);
        return;
      }

      const container = target.closest('.product-link-other');
      revealSelectedProductLink(container, container.querySelector('[aria-current="page"]'));
    });
  });

  const initializeProductLinks = (root = document) => {
    root.querySelectorAll('.product-link-other--images .product-link-other__options').forEach((track) => {
      productLinkResizeObserver.observe(track);
      const container = track.closest('.product-link-other');
      revealSelectedProductLink(container, container.querySelector('[aria-current="page"]'));
    });
  };

  initializeProductLinks();
  document.addEventListener('shopify:section:load', (event) => initializeProductLinks(event.target));

  let productLinkDrag = null;
  let suppressedProductLinkClick = null;

  document.addEventListener('pointerdown', (event) => {
    suppressedProductLinkClick = null;
    if (event.pointerType !== 'mouse' || event.button !== 0 || !(event.target instanceof Element)) return;

    const track = event.target.closest('.product-link-other--images .product-link-other__options');
    if (!track || track.scrollWidth <= track.clientWidth) return;

    productLinkDrag = {
      track,
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: track.scrollLeft,
      dragging: false,
    };
  });

  document.addEventListener('pointermove', (event) => {
    const drag = productLinkDrag;
    if (!drag || drag.pointerId !== event.pointerId) return;

    const distance = event.clientX - drag.startX;
    if (!drag.dragging) {
      if (Math.abs(distance) < 6) return;
      drag.dragging = true;
      drag.track.classList.add('product-link-other__options--dragging');
      drag.track.setPointerCapture(event.pointerId);
    }

    event.preventDefault();
    drag.track.scrollLeft = drag.startScrollLeft - distance;
  });

  const finishProductLinkDrag = (event) => {
    const drag = productLinkDrag;
    if (!drag || (event.pointerId !== undefined && drag.pointerId !== event.pointerId)) return;

    productLinkDrag = null;
    drag.track.classList.remove('product-link-other__options--dragging');
    if (drag.dragging) {
      suppressedProductLinkClick = drag.track;
      if (drag.track.hasPointerCapture(drag.pointerId)) drag.track.releasePointerCapture(drag.pointerId);
    }
  };

  document.addEventListener('pointerup', finishProductLinkDrag);
  document.addEventListener('pointercancel', finishProductLinkDrag);
  document.addEventListener('lostpointercapture', finishProductLinkDrag);
  window.addEventListener('blur', finishProductLinkDrag);

  document.addEventListener('dragstart', (event) => {
    if (productLinkDrag?.track.contains(event.target)) event.preventDefault();
  });

  document.addEventListener('click', (event) => {
    if (event.detail === 0 || !suppressedProductLinkClick) return;

    const track = suppressedProductLinkClick;
    suppressedProductLinkClick = null;
    if (event.target instanceof Element && track.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      !(event.target instanceof Element)
    ) {
      return;
    }

    const option = event.target.closest('.product-link-other__option');
    const container = option?.closest('.product-link-other');
    if (!container || option.hasAttribute('download') || (option.target && option.target !== '_self')) {
      return;
    }

    selectProductLink(container, option);
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    document.querySelectorAll('.product-link-other').forEach((container) => {
      selectProductLink(container, container.querySelector('[data-current-product]'));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shared-countdown-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shared-countdown-group')) {
    const changeEvent = 'shared-countdowns:change';
    const timestamp = (value = '') => {
      const milliseconds = /^\d+$/.test(value.trim()) ? Number(value) * 1000 : NaN;
      return Number.isSafeInteger(milliseconds) ? milliseconds : NaN;
    };
    const collectionKeys = (element, property) => {
      try {
        const values = JSON.parse(element.dataset[property] || '[]');
        return new Set(Array.isArray(values) ? values.filter((value) =>
          typeof value === 'string' || typeof value === 'number'
        ).map((value) => String(value).trim()).filter((value) =>
          property === 'countdownCollectionIds' ? /^\d+$/.test(value) : value.length > 0
        ) : []);
      } catch {
        return new Set();
      }
    };
    const collections = (element) => ({
      ids: collectionKeys(element, 'countdownCollectionIds'),
      handles: collectionKeys(element, 'countdownCollectionHandles'),
    });
    const matchesCollections = (target, definition) =>
      Array.from(target.ids).some((id) => definition.ids.has(id)) ||
      Array.from(target.handles).some((handle) => definition.handles.has(handle));

    if (!customElements.get('shared-countdown-config')) {
      customElements.define(
        'shared-countdown-config',
        class SharedCountdownConfig extends HTMLElement {
          constructor() {
            super();
            this.notifyChange = this.notifyChange.bind(this);
            this.onVisibilityChange = () => {
              if (document.visibilityState === 'visible') this.loadConfiguration(true);
            };
            this.onPageShow = (event) => {
              if (event.persisted) this.loadConfiguration(true);
            };
          }

          connectedCallback() {
            this.observer = new MutationObserver(this.notifyChange);
            this.observer.observe(this, {
              subtree: true,
              childList: true,
              attributes: true,
              attributeFilter: [
                'data-countdown-definition', 'data-countdown-id', 'data-countdown-collection-ids', 'data-countdown-collection-handles',
                'data-countdown-mode', 'data-end-timestamp', 'data-start-timestamp',
                'data-cycle-duration', 'data-cycle-unit',
              ],
            });
            this.notifyChange();
            document.addEventListener('visibilitychange', this.onVisibilityChange);
            window.addEventListener('pageshow', this.onPageShow);
            this.loadConfiguration();
          }

          disconnectedCallback() {
            this.observer?.disconnect();
            this.request?.controller.abort();
            this.request = null;
            document.removeEventListener('visibilitychange', this.onVisibilityChange);
            window.removeEventListener('pageshow', this.onPageShow);
            this.notifyChange();
          }

          notifyChange() {
            queueMicrotask(() => document.dispatchEvent(new Event(changeEvent)));
          }

          async loadConfiguration(force = false) {
            // Older cached pages have no section metadata; the global section has a static ID.
            const sectionId = this.dataset.sectionId || 'shared-countdowns';
            const themeId = this.dataset.themeId || String(window.Shopify?.theme?.id || '');
            const themeRole = this.dataset.themeRole || window.Shopify?.theme?.role;
            // Theme editor HTML includes unsaved changes; never replace it with saved storefront data.
            if (!this.isConnected || window.Shopify?.designMode || this.dataset.designMode === 'true' ||
              !document.querySelector('shared-countdown-group') ||
              !themeId || this.request ||
              (!force && this.lastRequestAt && Date.now() - this.lastRequestAt < 5000)) return;

            const request = {controller: new AbortController()};
            this.request = request;
            this.lastRequestAt = Date.now();
            const timeout = setTimeout(() => request.controller.abort(), 5000);
            this.dataset.configState = 'loading';
            try {
              const url = new URL(window.location.href);
              url.searchParams.delete('sections');
              url.searchParams.set('section_id', sectionId);
              if (themeRole && themeRole !== 'main') {
                url.searchParams.set('preview_theme_id', themeId);
              }
              url.searchParams.set('_countdown_refresh', String(Date.now()));
              const response = await fetch(url, {
                cache: 'no-store',
                credentials: 'same-origin',
                signal: request.controller.signal,
              });
              if (!response.ok) throw new Error('Countdown configuration request failed');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const config = html.querySelector('shared-countdown-config');
              if (!config || config.dataset.themeId !== themeId ||
                config.dataset.sectionId !== sectionId ||
                config.dataset.configVersion !== 'fresh-config-v2') {
                throw new Error('Unexpected countdown configuration');
              }
              if (!this.isConnected || this.request !== request) return;

              // Import definitions only, so section scripts and unrelated markup cannot execute twice.
              this.replaceChildren(...config.querySelectorAll(':scope > [data-countdown-definition]'));
              this.dataset.configVersion = config.dataset.configVersion;
              this.dataset.themeId = themeId;
              this.dataset.themeRole = config.dataset.themeRole || themeRole || '';
              this.dataset.sectionId = sectionId;
              this.dataset.configRenderedAt = config.dataset.configRenderedAt || '';
              this.dataset.configState = 'loaded';
            } catch {
              // Keep the server-rendered countdown usable when refresh is unavailable or offline.
              if (this.isConnected && this.request === request) this.dataset.configState = 'error';
            } finally {
              clearTimeout(timeout);
              if (this.request === request) this.request = null;
            }
          }
        }
      );
    }

    customElements.define(
      'shared-countdown-group',
      class SharedCountdownGroup extends HTMLElement {
        constructor() {
          super();
          this.refresh = this.refresh.bind(this);
          this.update = this.update.bind(this);
        }

        connectedCallback() {
          this.refresh();
          this.observer = new MutationObserver((mutations) => {
            if (mutations.some((mutation) => mutation.type === 'attributes' ||
              Array.from([...mutation.addedNodes, ...mutation.removedNodes]).some((node) =>
                node.nodeType === Node.ELEMENT_NODE
              ))) this.refresh();
          });
          this.observer.observe(this, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['data-countdown-collection-ids', 'data-countdown-collection-handles'],
          });
          document.addEventListener(changeEvent, this.refresh);
          document.addEventListener('visibilitychange', this.update);
          document.querySelector('shared-countdown-config')?.loadConfiguration?.();
        }

        disconnectedCallback() {
          this.stop();
          this.observer?.disconnect();
          document.removeEventListener(changeEvent, this.refresh);
          document.removeEventListener('visibilitychange', this.update);
        }

        refresh() {
          this.stop();
          const definitions = Array.from(
            document.querySelectorAll('shared-countdown-config [data-countdown-definition]')
          ).map((definition) => {
            const duration = definition.dataset.cycleDuration?.trim() || '';
            const unit = {minutes: 60000, hours: 3600000, days: 86400000}[definition.dataset.cycleUnit];
            const cycleMilliseconds = /^\d+$/.test(duration) ? Number(duration) * unit : NaN;
            return {
              id: definition.dataset.countdownId,
              collections: collections(definition),
              mode: definition.dataset.countdownMode || 'fixed',
              showDays: definition.dataset.countdownMode !== 'evergreen' || definition.dataset.cycleUnit === 'days',
              deadline: timestamp(definition.dataset.endTimestamp),
              start: timestamp(definition.dataset.startTimestamp),
              cycle: Number.isSafeInteger(cycleMilliseconds) && cycleMilliseconds > 0 ? cycleMilliseconds : NaN,
            };
          }).filter((definition) => {
            if (definition.mode === 'evergreen') {
              return Number.isSafeInteger(definition.start) && Number.isSafeInteger(definition.cycle);
            }
            return definition.mode === 'fixed' && Number.isSafeInteger(definition.deadline);
          });

          this.countdowns = Array.from(this.querySelectorAll(':scope > shared-countdown')).map((element) => {
            element.hidden = true;
            const targetCollections = collections(element);
            const matches = definitions.filter((definition) => matchesCollections(targetCollections, definition.collections));
            element.toggleAttribute('data-countdown-matched', matches.length > 0);
            return {
              element,
              definitions: matches,
              days: element.querySelector('[data-days]'),
              daysSeparator: element.querySelector('[data-days-separator]'),
              hours: element.querySelector('[data-hours]'),
              minutes: element.querySelector('[data-minutes]'),
              seconds: element.querySelector('[data-seconds]'),
            };
          }).filter(({ days, daysSeparator, hours, minutes, seconds }) => days && daysSeparator && hours && minutes && seconds);

          this.update();
        }

        stop() {
          clearTimeout(this.timeout);
          this.timeout = null;
        }

        update() {
          clearTimeout(this.timeout);
          const now = Date.now();
          let nextUpdate = null;
          this.countdowns.forEach((countdown) => {
            let active;
            for (const definition of countdown.definitions) {
              let deadline = definition.deadline;
              if (definition.mode === 'evergreen') {
                if (!Number.isSafeInteger(definition.start) || !Number.isSafeInteger(definition.cycle)) continue;
                if (definition.start > now) {
                  nextUpdate = Math.min(nextUpdate ?? Infinity, definition.start - now);
                  continue;
                }
                deadline = now - ((now - definition.start) % definition.cycle) + definition.cycle;
              } else if (definition.mode !== 'fixed') {
                continue;
              }
              if (!active && Number.isSafeInteger(deadline) && deadline > now) {
                active = {id: definition.id, deadline, showDays: definition.showDays};
              }
            }
            countdown.element.hidden = !active;
            if (!active) {
              delete countdown.element.dataset.countdownId;
              return;
            }

            countdown.element.dataset.countdownId = active.id;
            const remainingMilliseconds = active.deadline - now;
            const remainingSeconds = Math.ceil(remainingMilliseconds / 1000);
            const totalHours = Math.floor(remainingSeconds / 3600);
            countdown.days.hidden = !active.showDays;
            countdown.daysSeparator.hidden = !active.showDays;
            countdown.days.textContent = String(Math.floor(remainingSeconds / 86400)).padStart(2, '0');
            countdown.hours.textContent = String(active.showDays ? totalHours % 24 : totalHours).padStart(2, '0');
            countdown.minutes.textContent = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, '0');
            countdown.seconds.textContent = String(remainingSeconds % 60).padStart(2, '0');
            nextUpdate = Math.min(nextUpdate ?? 1000, remainingMilliseconds, 1000);
          });

          if (nextUpdate === null) {
            this.stop();
            return;
          }
          this.timeout = setTimeout(this.update, Math.min(nextUpdate, 2147483647));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
